import { render } from "./customer-details-paid.vue?vue&type=template&id=0badac59"
import script from "./customer-details-paid.vue?vue&type=script&lang=js"
export * from "./customer-details-paid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__